module.exports = __webpack_public_path__ + "static/media/music-alt.3c23b0f6.svg";